import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const apartmentSearchDataForm: Form<Client> = {
  key: 'apartmentSearchData',
  title: 'Wohnungssuche',
  fields: [
    {
      key: 'registrationHousingAuthority',
      label: 'Anmeldung Wohnungsamt',
      fieldTypes: 'text',
    },
    {
      key: 'registrationHousingAuthorityNumber',
      label: 'Wohnungsamtnummer',
      fieldTypes: 'text',
    },
    {
      key: 'housingEligibilityCertificate',
      label: 'Wohnberechtigungsschein',
      fieldTypes: 'text',
    },
    {
      key: 'schufaEntry',
      label: 'Schufa Eintrag',
      fieldTypes: 'select',
      options: [
        {
          value: 'yes',
          label: 'Ja',
        },
        {
          value: 'no',
          label: 'Nein',
        },
        {
          value: 'unknown',
          label: 'unbekannt',
        },
      ],
    },
    {
      key: 'apartmentSearch',
      label: 'Wohnungssuche',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
    {
      key: 'leaseAgreementDate',
      label: 'Mietvertrag ab',
      fieldTypes: 'date',
    },
    {
      key: 'forwardMail',
      label: 'Post nachsenden',
      fieldTypes: 'checkbox',
    },
    {
      key: 'newApartment',
      label: 'Neue Wohnung',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default apartmentSearchDataForm;
